// import axios from "axios";
import React from "react";



import { useNavigate } from "react-router-dom";
import TableData from "../Partials/TableData3";

export const Listuser = () => {
  const path = "User"
  const navigate = useNavigate();
 // EditClick function is used to navigate to adduserform with particular User details
  const editClick = (item) => {
    navigate(`../addnewuser/${item._id}`);
  }

return (
    <React.Fragment>
      <div className="add-user-container">
     <div className="headingdiv">
      <span className="componet-title">Users List</span>
         <div>
            <button onClick={() => { navigate(-1) }}>Back</button>
          </div>
        </div>
 <div className="option-btn">
          <button onClick={() => { navigate("/addnewuser") }}>Add New User</button>
        </div>
        {/* This component is for list of user Table */}
        {/* Here passing Path as props  */}
        <TableData path={path} editClick={editClick} />
    </div>
    </React.Fragment>
  );
}


